define('models/UserModel',[
    "evertrue",
    "underscore",
    "backbone",
    "moment",
    "ET/ETModel",
    "models/contact/ContactModel",
    "models/affiliation/AffiliationModel"
], function UserModelFactory ( EverTrue, _, Backbone, moment, ETModel, ContactModel, AffiliationModel) {

    var roles = [];
    if (EverTrue.Organization) {
        var temp_roles = EverTrue.Organization.get("roles");
        if (temp_roles && temp_roles.length) {
            $.each(temp_roles, function(index){
                var temp_obj = {};
                temp_obj["val_display"] = temp_roles[index].name;
                temp_obj["val"] = temp_roles[index].id;
                roles.push(temp_obj);
            });
        }
    }

    // Read only (for now) helper accesser to the user's data
    var UserModel = ETModel.extend({
        storageName: "user",
        displayAttrs : [
            "name",
            "email"
        ],
        defaults: {
            "id"    : "",
            "name"  : "",
            "email" : "",
            "affiliations" : []
        },
        urlRoot : "auth/users/",
        initialize: function (id) {
            var self = this;
            this.setRavenUser();
            this.on("change", function(){
                self.setRavenUser();
            }, this);

            if (id) {
                this.urlRoot = "auth/users/" + id + "/";
            }

            this.affiliation = new AffiliationModel();
            this.affiliation.set(this.getUserAffiliation());

            // update user when the user portion of the session changes
            EverTrue.Session.on('change:user', this.update, this);
        },

        setRavenUser: function() {
            var data = {
                email: this.get('email'),
                user_id: this.get('id'),
                super_user: this.get('super_user'),
                organization: EverTrue.Organization.get("id")
            };
            Raven.setUser(data);
        },

        update : function(){
            var user = (EverTrue.Session && EverTrue.Session.has('user')) ? EverTrue.Session.get('user') : {};
            this.set(user);
            EverTrue.amplify('user', user);
        },

        getAvatar: function() {
            var self = this,
                user = self.toJSON(),
                avatar = "https://s3.amazonaws.com/assets.evertrue.com/global/default_avatar@2x.png";

            // TODO: Linkedin Needs to be Hooked up here for this to work
            if (user && user.linkedin && user.linkedin.properties) {
                avatar = _.findWhere(user.linkedin.properties, {name: "picture_url"}) || avatar;
            }
            return avatar;
        },

        getAttributes: function() {
            var view = this,
                user_attributes = this.toJSON(),
                org_id = EverTrue.Organization.get("id"),
                affiliation = view.getUserAffiliation();

            user_attributes.affiliation = (affiliation) ? affiliation : {};
            user_attributes.roles = (affiliation.roles) ? affiliation.roles : [];
            user_attributes.contact_id = (affiliation.contact_id) ? affiliation.contact_id : "";

            user_attributes.affiliation_created_timestamp = (affiliation.created_at) ? affiliation.created_at : "",
            user_attributes.affiliation_created_at = (affiliation.created_at) ?
                moment(affiliation.created_at).format("MMM Do, YYYY [at] h:mm a") : "";

            if (user_attributes.affiliation_requests && user_attributes.affiliation_requests.length > 0) {
                request = user_attributes.affiliation_requests[0];
                var aff_request_org_id = "";
                if (request.organization) { // user search format
                    aff_request_org_id = request.organization.id;
                } else if (request.organization_id) { // affiliation request endpoint format
                    aff_request_org_id = request.organization_id;
                }
                if (aff_request_org_id == EverTrue.Organization.get("id")) {
                    user_attributes.affiliation_request = request;
                }
            }

            this.set(user_attributes);

            // check if this user is logged in
            if (EverTrue.User.id == this.get("id")) {
                user_attributes.logged_in = true;
            }
            return user_attributes;
        },

        save: function(crudType, changed, done) {
            var view = this,
                params = {},
                checked = (changed.role) ? changed.role : [],
                checked_roles = [];

            params.email = (changed.email) ? changed.email : "";
            params.name = (changed.name) ? changed.name : "";

            // Get roles that are checked in the modal
            if (_.isArray(checked)) {
                _.each(checked, function(role) {
                    checked_roles.push(parseInt( role, 10 ));
                });
            } else if (checked) {
                checked_roles.push(parseInt(checked, 10));
            }

            // If creating user
            if (crudType == "create") {
                view.createUser(params, checked_roles, done);
            // Else if updating user
            } else {
                // Only allow user to update their name and email, if its the same as logged in user
                if (this.get("id")== EverTrue.User.id) {
                    view.updateUserInfo(params);
                    this.set(params);
                }

                // Update Roles
                // If user has a contact, update roles_override on the contact
                view.affiliation.set(view.getUserAffiliation());
                if (view.affiliation.get("contact_id")) {
                    var contact = new ContactModel();
                    contact.set("id", view.affiliation.get("contact_id"));
                    $.when(contact.fetch()).done(function(resp) {
                        contact.set("role", checked_roles);
                        contact.saveRolesOverride(resp, function() {
                            if (_.isFunction(done)){
                                // Need a slight delay because the contacts roles_override takes
                                // a second to update the users roles
                                setTimeout(done, 1000);
                            }
                        });
                    });
                } else {
                    view.affiliation.updateRoles(checked_roles, done);
                }
            }

        },

        sendPasswordEmail: function(msg, resp, done) {
            EverTrue.alertView.alert("success", {header: "Success", message: msg + ", Password Email Sent"});
            // Send reset password email
            EverTrue.api({
                url: "auth/registrations/password",
                type: "POST",
                contentType: 'application/json',
                data: {user: {email: resp.email }},
                success: function(resp) {}
            }, this);
            if (_.isFunction(done)){
                done();
            }
        },

        createUser: function(params, checked_roles, done) {
            var view = this,
                user_affiliations = [],
                options = {},
                aff = {
                    "legacy_user_id" : "",
                    "organization_id" : EverTrue.Organization.get("id"),
                    "role_ids" : checked_roles
                    },
                msg = "User Created";

            user_affiliations.push(aff);
            params.affiliations = user_affiliations;

            options = {
                success: function(resp){
                    view.sendPasswordEmail(msg, resp, done);
                },
                statusCode: {
                    422: function(xhr, textStatus, resp) {
                        EverTrue.api({
                            url: view.urlRoot + "email/" + params.email,
                            success: function (resp) {
                                var affiliation = new AffiliationModel();
                                affiliation.createAffiliation({
                                    data: {
                                        user_id: resp.id,
                                        role_ids: checked_roles
                                    },
                                    success: function(response) {
                                        view.sendPasswordEmail(msg, {email: params.email}, done);
                                    }
                                });
                            }
                        }, view);
                    }
                },
                url : "auth/users/",
                params : params,
                type : "POST",
                headers : {Accept: "application/json"},
                contentType: "application/json"
            };
            return EverTrue.api(options, this);
        },

        updateUserInfo: function(params) {
            var options = {
                success: function(resp) {
                    EverTrue.alertView.alert("success", {header: "Success", message: "User Updated"});
                },
                url : "auth/registrations/",
                params : params,
                type : "PUT",
                headers : {Accept: "application/json"},
                contentType: "application/json"
            };
            EverTrue.api(options, this);
        },

        getUserAffiliation: function() {
            var affiliation = "",
                existing_roles = [],
                org_id = EverTrue.Organization.get("id"),
                affiliations = this.get("affiliations");

            _.each(affiliations, function(aff) {
                // affiliation can vary if getting user from search or from auth/users (TODO - should this change?)
                if ((aff && aff.organization && aff.organization.id == org_id) ||
                    (aff && aff.organization_id && aff.organization_id == org_id)) {
                    affiliation = aff;
                    _.each(aff.affiliation_roles, function(aff_role) {
                        var role_id = "",
                            role_name = (aff_role.role && aff_role.role.name) ? aff_role.role.name : "";
                        if (aff_role.role && aff_role.role.id) {
                            role_id = aff_role.role.id;
                        } else if (aff_role.role_id) {
                            role_id = aff_role.role_id;
                        }
                        existing_roles.push({id: role_id, name: role_name});
                    });
                }
            });
            if (existing_roles.length) {
                affiliation.roles = existing_roles;
            }
            return affiliation;
        }

    });

    return UserModel;
});

